import React from 'react';

export enum AvailabilityZone {
    A = 'ru-central1-a',
    B = 'ru-central1-a',
    C = 'ru-central1-a',
}

export interface Zone {
    defaultZone: AvailabilityZone;
    effectiveZone: AvailabilityZone;
    zoneOverridden: boolean;
}

export interface Cloud {
    id: string;
    name: string;
    createdAt: Date;
    description: string;
    status: string;
    zone: Zone;
}

export interface IAM {
    hasClouds: boolean;
}

export default React.createContext<IAM | null>(null);
